define('views/conversations/Podio.Views.Conversations.Chat.List',['require','translate','underscore','lib/backbone/Backbone.PodioCollectionView','views/conversations/Podio.Views.Conversations.Chat.ListItem','models/Podio.Models.ChatShowMore','lib/Podio.Router','lib/Podio.Routes','jst!conversations/chat/_show_more','jst!shared/generic_loader_small','jst!shared/generic_warning'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var PodioCollectionView = require('lib/backbone/Backbone.PodioCollectionView');
  var ConversationsListItemView = require('views/conversations/Podio.Views.Conversations.Chat.ListItem');
  var ModelChatShowMore = require('models/Podio.Models.ChatShowMore');
  var router = require('lib/Podio.Router');
  var routes = require('lib/Podio.Routes');

  var jstShowMore = require('jst!conversations/chat/_show_more');
  var jstGenericWarningSmall = require('jst!shared/generic_loader_small');
  var jstGenericWarning = require('jst!shared/generic_warning');

  var conversationsListView = PodioCollectionView.extend({

    tagName: 'ul',
    className: 'navigation-container',

    initialize: function() {
      _.bindAll(this, 'onConversationRemoved', 'clearRerenderRestore');

      this.elmTarget = this.options.elmTarget;

      this.itemView = ConversationsListItemView;
      this._super();

      this.elmItemsContainer = this.elmTarget;
      this.elmItemsList = this.elm;

      this.itemViewOptions = function() {
        return {
          eventBus: this.options.eventBus
        };
      };
    },

    _bindEvents: function() {
      this.listenTo(this.collection, 'sort', this.onCollectionResorted);
      this.listenTo(this.collection, 'remove', this.onConversationRemoved);
      this.listenTo(this.eventBus, 'conversationsCollection:unreadCountChanged', this.onTotalUnreadCountChanged);
      this._bindToCollection();
    },

    _renderShowMore: function() {
      var elmShowMore = this.elmTarget.find('.show-more-container');

      if (this.showMoreModel && this.collection.length >= this.collection.itemsPerRequest) {
        var showMoreHtml = this.getTemplate(jstShowMore, {
          count: this.showMoreModel.get('showMoreUnreadCount'),
          translations: {
            showMore: t('Show more conversations #conversations.chat')
          },
          url: routes.html_conversations_path({format:''})
        });

        if (elmShowMore.length) {
          elmShowMore.replaceWith(showMoreHtml);
        } else {
          this.elmTarget.append(showMoreHtml);
        }

      } else if (elmShowMore.length) {
        elmShowMore.remove();
      }
    },

    _initShowMoreModel: function() {
      if (this.showMoreModel) {
        //this.showMoreModel.off('change:showMoreUnreadCount', this.clearRerenderRestore);
        this.showMoreModel.destroy();
      }

      this.showMoreModel = new ModelChatShowMore({
        totalUnreadCount: this.options.headerCounters.getConversationsCount(),
        conversations: this.collection
      });

      //this.showMoreModel.on('change:showMoreUnreadCount', this.clearRerenderRestore);
    },

    renderWaiting: function() {
      this.elmTarget.html(this.getTemplate(jstGenericWarningSmall));
    },

    render: function() {
      this._super();

      if (this.collection.length > 0) {
        this.elmTarget.html(this.elm);
      }

      if (this.collection.totalUnreadCount && this.showMoreModel) {
        this.showMoreModel.set('totalUnreadCount', this.collection.totalUnreadCount);
        delete this.collection.totalUnreadCount;
      }
      this._renderShowMore();

      this.eventBus.trigger('conversationListView:rendered');

      return this;
    },

    renderEmptyView: function() {
      this.elmTarget.html(this.getTemplate(jstGenericWarning, { message: t("You don't have any conversations. #conversations") }));
    },

    setCollection: function(collection) {
      this.stopListening();
      this.collection = collection;
      this._bindEvents();
      this._initShowMoreModel();
    },

    clear: function() {
      this.elmTarget.empty();
    },

    clearRerenderRestore: function() {
      // Re-render entire list when collection is re-sorted
      // to ensure that all conversation are listed in correct order
      this.clear();
      this.render();

      // restore the selected conversation
      if (this.options.sharedState.selectedConversationModel) {
        var view = this.children.findByModelId(this.options.sharedState.selectedConversationModel.get('id'));
        if (view) {
          view.elm.addClass('selected');
        }
      }
    },

    onCollectionResorted: function() {
      this.clearRerenderRestore();
    },

    onConversationRemoved: function(conversation) {
      this.removeItemView(conversation);
    },

    dispose: function() {
      this.elmTarget.find('.show-more-container').remove();
      this._super();
    }

  });

  return conversationsListView;

});

